import { render, staticRenderFns } from "./DeleteVersionBtn.vue?vue&type=template&id=d062b55a&"
import script from "./DeleteVersionBtn.js?vue&type=script&lang=js&"
export * from "./DeleteVersionBtn.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports